import styled from 'styled-components'

export const SearchTabsCss = styled.div`
  display: flex;
  justify-content: center;
  .tab {
    display: flex;
    margin-right: 20px;
    color: ${props => props.theme.isAlpha ? '#fff' : '#000'};
    cursor: pointer;
    &:last-of-type {
      margin-right: 0;
    }
    &.active {
      border-bottom: 2px solid #000;
      border-bottom-color: ${props => props.theme.isAlpha ? '#fff' : '#000'};
    }
  }
`
